module.exports = __webpack_public_path__ + "media/images/official/plan_ticket_icon6-435ed8d645512973d557020a32d9fa68.svg";